import React, { useEffect } from 'react';
import "./style.sass";
import { useIsMobile } from 'hooks/useIsMobile';
import { SolicitarTarjetaDesktop } from './solicitarTarjetaDesktop';
import { SolicitarTarjetaMobile } from './solicitarTarjetaMobile';
import { removeStorage } from 'functions/storageBase64';

export default function SolicitarTarjeta() {
    const { isMobile } = useIsMobile();

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Request Card Credit-Page')
        window.ineum('meta', 'portal', 'Credito')
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        removeStorage('infoPersonalStorage')
        removeStorage('infoPersonal2Storage')
        removeStorage('infoTrabajoStorage')
        removeStorage('infoFinancieraStorage')

        removeStorage('infoPersonalMobileStorage')
        removeStorage('infoTrabajoMobileStorage')
        removeStorage('infoFinancieraMobileStorage')
    }, [])


    return (
        <>
            { isMobile &&
                isMobile === 'desktop'
                ? <SolicitarTarjetaDesktop />
                : <SolicitarTarjetaMobile />
            }
        </>
    )
}